import { PRICE_TYPES } from 'shared/consts/productTemplates'
import type { PageType } from 'types/cmsTypes'
import getImageUrl from 'views/components/organisms/AlgoliaInstantSearch/Algolia/getImageUrl'
import { calculateRetailPrice } from 'views/utils/esCompatibilityUtils'

import { EXCLUDED_PAGE_TYPES } from './consts'
import {
  type SearchHistorySuggestion,
  type SearchHit,
  type TopProductsAndSearchesParams,
} from './types'

export const convertHitToSuggestion = ({
  cdnUrl,
  product,
  queryID,
  isRebrandingEnabled,
  placeholderFromCdn,
}: {
  cdnUrl: string
  product: SearchHit
  queryID?: string
  isRebrandingEnabled?: boolean
  placeholderFromCdn?: boolean
}): SearchHit => {
  const {
    productName: name,
    pzn: id,
    price,
    averageRating,
    deeplink,
    variants,
    objectID,
    prescriptionMedicine,
    hasVariants,
  } = product

  let lowestPrice = Number(price)
  let newName = name
  let newDeepLink = deeplink

  variants?.forEach(({ retailPrice, productName, webDetailPath }) => {
    if (lowestPrice > Number(retailPrice)) {
      lowestPrice = Number(retailPrice)
      newName = productName
      newDeepLink = webDetailPath
    }
  })

  return {
    id,
    queryID,
    objectID,
    deeplink: newDeepLink,
    name: newName,
    averageRating,
    prices: [
      {
        amount: lowestPrice ? calculateRetailPrice(lowestPrice) : price,
        type: PRICE_TYPES.RETAIL,
      },
    ],
    thumbnailURL: getImageUrl({
      product,
      cdnUrl,
      isRebrandingEnabled,
      placeholderFromCdn,
    }),
    prescriptionMedicine,
    hasVariants,
  }
}

export const convertHitToHistorySuggestion = ({
  product,
  queryID,
}: {
  product: SearchHit
  queryID?: string
}): SearchHistorySuggestion => ({
  queryID,
  ...product,
})

export const getTopProductsAndSearches = async ({
  deviceClass,
  expa,
  searchClient,
  algolia,
}: TopProductsAndSearchesParams) => {
  const { suggestIndexName, topSellerCountIndex } = algolia

  const ruleContexts: string[] = ['pqsl']
  if (expa) {
    ruleContexts.push(expa)
  }
  const queries = [
    {
      indexName: suggestIndexName,
      query: '',
      params: {
        hitsPerPage: 3,
        ruleContexts,
        analyticsTags: ['pqsl', deviceClass],
        clickAnalytics: true,
      },
    },
    {
      indexName: topSellerCountIndex,
      query: '',
      params: {
        filters: 'stockStatusReason:product.stockStatus.available',
        hitsPerPage: 4,
        ruleContexts,
        analyticsTags: ['pqsl', deviceClass],
        clickAnalytics: true,
      },
    },
  ]
  return await searchClient.multipleQueries(queries)
}

export const shouldRenderPqsl = (pageType?: PageType): boolean =>
  typeof pageType !== 'undefined' && !EXCLUDED_PAGE_TYPES.includes(pageType)
